// Page states on the prototype's own blocks: z-empty (dashed box, h3 + soft p + z-button) and z-error text.
import type { ButtonHTMLAttributes, ReactNode } from 'react'

export function ProtoButton({ className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" className={`z-button ${className} cursor-interaction`.replace(/\s+/g, ' ').trim()} {...props} />
}

export function ProtoLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="z-empty" role="status" aria-live="polite" aria-busy="true">
      <p>{label}</p>
    </div>
  )
}

export function ProtoEmpty({ title, body, action, level }: { title: string; body?: ReactNode; action?: ReactNode; level?: number }) {
  return (
    <div className="z-empty">
      <h3 aria-level={level}>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action}
    </div>
  )
}

export function ProtoError({ title, body, actions, level }: { title: string; body?: ReactNode; actions?: ReactNode; level?: number }) {
  return (
    <div className="z-empty" role="alert">
      <h3 aria-level={level}>{title}</h3>
      {body ? <p><span className="z-error">{body}</span></p> : null}
      {actions}
    </div>
  )
}
